import React from 'react';
import termsAndConditionsIcon from 'assets/images/terms_and_conditions_icon.svg';
import privacyNoticeIcon from 'assets/images/privacy_notice_icon.svg';
import './styles.less';
import { AppConstants } from 'core/app.constants';
import { AvailableDocumentTypes } from 'utils/enums';

interface ILegalDocumentOptionsProps {
  currentCountry: string,
  documentTypeSelected: string,
  onTermsClicked: any,
  onPrivacyClicked: any,
  t: any
}

const LegalDocumentsOptionsComponent = (props: ILegalDocumentOptionsProps) => {
  return (
    <div
      className="legal-options-list"
      data-testid="legal-options-list"
      style={{
        marginTop: '14px',
        display: AppConstants.SUPPORTED_COUNTRIES.filter((c) => c.value === props.currentCountry).length === 0 ? 'none' : 'block',
      }}
    >
      <div className="legal-buttons">
        <div
          className={props.documentTypeSelected === AvailableDocumentTypes.TERMS ? 'legal-button-container container-selected' : 'legal-button-container'}
          onClick={props.onTermsClicked}
          data-testid="terms-and-conditions-container"
        >
          <img style={{marginRight: '10px'}} src={termsAndConditionsIcon} />
          {props.t('global.text.terms_and_conditions')}
        </div>
        <div
          className={props.documentTypeSelected === AvailableDocumentTypes.PRIVACY ? 'legal-button-container container-selected' : 'legal-button-container'}
          onClick={props.onPrivacyClicked}
        >
          <img style={{marginRight: '10px'}} src={privacyNoticeIcon} />
          {props.t('global.text.privacy_notice')}
        </div>
      </div>
    </div>
  )
}

export default LegalDocumentsOptionsComponent;